import { FieldValues } from 'react-hook-form';

import { Stack, StackProps, styled } from '@mui/material';

import clsx from 'clsx';

import Button, { Props as ButtonProps } from '../../../../../components/Button';
import AcadlyDrawer, { drawerClasses as acadlyDrawerClasses } from '../../../../../components/Drawer';
import Checkbox from '../../../../../components/HookFormControls/Checkbox';
import Switch, { Props as SwitchProps } from '../../../../../components/HookFormControls/Switch';
import Typography, { Props as TypographyProps } from '../../../../../components/Typography';
import { generateClasses } from '../../../../../utils/helper';

const editPublishPreferencesDrawerClasses = {
  ...generateClasses('EditPublishPreferencesDrawer', ['cellButton', 'chevron', 'switch', 'switchLabel']),
};

export const Drawer = styled(AcadlyDrawer)(({ theme }) => ({
  [`& .${acadlyDrawerClasses.body}`]: {
    padding: theme.spacing(2, 4),
  },
  [`& .${acadlyDrawerClasses.footer}`]: {
    padding: theme.spacing(2, 4),
  },
}));

export const SaveAsDefaultCheckbox = styled(Checkbox)(() => ({
  marginRight: 'auto',
})) as typeof Checkbox;

export const Cell = styled((props: StackProps) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" gap={5} {...props} />
))(() => ({}));

export const CellLabel = styled((props: TypographyProps) => (
  <Typography variant="h6Bold" color="grey.800" {...props} />
))(() => ({}));

export const CellValue = styled((props: TypographyProps) => (
  <Typography variant="h6Regular" color="grey.800" {...props} />
))(() => ({}));

export const CellButton = styled((props: ButtonProps) => (
  <Button
    variant="text"
    {...props}
    className={clsx(editPublishPreferencesDrawerClasses.cellButton, props.className)}
    classes={{
      ...props.classes,
      endIcon: clsx(editPublishPreferencesDrawerClasses.chevron, props.classes?.endIcon),
    }}
  />
))(({ theme }) => ({
  [`&.${editPublishPreferencesDrawerClasses.cellButton}`]: {
    color: theme.palette.grey[400],
    margin: theme.spacing(-3),
    width: `calc(100% + ${theme.spacing(3 * 2)})`,
    [`& .${editPublishPreferencesDrawerClasses.chevron}`]: {
      '& > *': {
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },
}));

export const SectionTitle = styled((props: TypographyProps) => (
  <Typography variant="h6Bold" color="grey.900" {...props} />
))(() => ({}));

export const StyledSwitch = styled(<T extends FieldValues>(props: SwitchProps<T>) => (
  <Switch
    labelPlacement="start"
    {...props}
    className={clsx(editPublishPreferencesDrawerClasses.switch, props.className)}
    classes={{
      ...props.classes,
      label: clsx(editPublishPreferencesDrawerClasses.switchLabel, props.classes?.label),
    }}
  />
))(({ theme }) => ({
  [`&.${editPublishPreferencesDrawerClasses.switch}`]: {
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(3),
    [`& .${editPublishPreferencesDrawerClasses.switchLabel}`]: {
      ...theme.typography.h6Bold,
      color: theme.palette.grey[900],
    },
  },
})) as typeof Switch;

export const SwitchHelperText = styled((props: TypographyProps) => (
  <Typography variant="paragraphRegular" {...props} />
))(({ theme }) => ({
  /** marginRight = width of switch (=52px) + gap between label and switch (=12px) */
  marginRight: theme.spacing(16),
  color: theme.palette.grey[900],
}));
